// extracted by mini-css-extract-plugin
export default {"linhaSalvar":"ModalCadastro_linhaSalvar__okq68","alerta":"ModalCadastro_alerta__HJVgR"};